module.exports = __webpack_public_path__ + "static/media/key-message-blood-thinner.f2e4728b.svg";